import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

/**
 * Props for Passkey Auth Failed event.
 */
export interface PasskeyAuthFailedProps extends EventProps {
    error?: string
}

/**
 * @event passkey_auth_failed
 */
export const PasskeyAuthFailedAnalytics = createAnalyticsStatic<PasskeyAuthFailedProps>(
    ANALYTICS_EVENTS.PASSKEY.AUTH_FAILED,
)

export default PasskeyAuthFailedAnalytics
